
import { useLanguage as useLanguageFromContext } from '../context/LanguageContext';

// This is a simple re-export for convenience
export const useLanguage = useLanguageFromContext;
